import { NextApiService } from '@services/next-api-service';
import { Component, h, Prop, State } from '@stencil/core';
import { pathStore } from '@store/path-store';
import { CuratedOffersLayoutProps, ObopDataProps } from './types';

@Component({
  tag: 'section-curated-offers',
  styleUrl: 'section-unbeateable-deals.scss',
  shadow: true
})
export class SectionCuratedOffers {
  @Prop() data: CuratedOffersLayoutProps;
  @State() obop: ObopDataProps;
  @State() isLoading: boolean = true;
  @State() error: string | null = null;

  private nextApiService = new NextApiService();

  async getCuratedOffers() {
    this.isLoading = true;
    this.error = null;

    try {
      const req = {
        category: 'All',
        location: { city: '', cityES: '' },
        details: true,
        includeCampaigns: false,
        choiceCount: 5,
        campaignCount: 2,
        uuid: null
      };
      const input = encodeURIComponent(JSON.stringify({ '0': { json: req } }));
      const response = await this.nextApiService.get(`/obopChoiceList.getObopOffers?batch=1&input=${input}`);
      this.obop = response;
    } catch (err) {
      console.error('[CuratedOffers] Failed to fetch offers:', err);
      this.error = 'Failed to load offers. Please try again.';
    } finally {
      this.isLoading = false;
    }
  }

  componentWillLoad() {
    this.getCuratedOffers();
  }

  curatedCardClick = (itemId: string, name: string, offerId: string) => {
    const curatedCardRedirection = `${window.location.origin}/justforyou/offer-details/${itemId}/${encodeURIComponent(name)}/${offerId}`;
    window.location.href = curatedCardRedirection;
  }

  render() {
    const assetPath = pathStore.assetPath;
    // 👉 Loader skeleton
    if (this.isLoading) {
      return <curated-offers-skeleton />;
    }

    // 👉 Error fallback
    if (this.error) {
      return (
        <div class="text-center text-sm text-red-500 py-10 px-4">
          <p>{this.error}</p>
          <button onClick={() => this.getCuratedOffers()} class="mt-4 px-4 py-2 bg-red-500 text-white rounded-md text-sm">
            Retry
          </button>
        </div>
      );
    }

    // 👉 No data
    if (!this.obop || !this.obop.items?.length) {
      return null
    }

    // 👉 Render actual content
    return (
      <div>
        <div class="flex justify-between py-4 px-4">
          <p class="text-base font-bold text-black leading-6">{this.data?.title}</p>
          {this.data.viewAllLink && (
            <a href={this.data.viewAllLink}>
              <img src={`${assetPath}images/icons/right_circle_arrow.svg`} alt={this.data?.title} height="16" />
            </a>
          )}
        </div>

        <div class="overflow-x-auto py-2 no-scrollbar">
          <div class="flex items-stretch gap-5">
            {this.obop.items.map(({ item }: any) => (
              <div onClick={() => this.curatedCardClick(item.id, item.name, item.offers?.id)} key={item.id} class="p-2 rounded-2xl bg-white shrink-0 w-full max-w-3xs flex flex-col shadow-xl" style={{ boxShadow: '0px 2px 16px 0px #0000001F' }}>
                <div class="relative">
                  <div class="h-28 w-full overflow-hidden rounded-t-lg">
                    <img src={item.offers?.properties.curatedOfferImage} alt={item.name} class="h-full w-full object-cover rounded-t-lg" />
                  </div>
                  <div class="absolute left-2 -bottom-6">
                    <div class="h-11 w-11 rounded-xl border-2 border-white overflow-hidden bg-white">
                      <img src={item.properties.brandLogo} alt="brand" class="h-full w-full object-cover" />
                    </div>
                  </div>
                </div>
                <div class="relative pt-6">
                  <p class="text-[#374151] text-xs font-medium">{item.name}</p>
                  <p class="text-[#111827] text-base font-normal pt-1 pb-2">{item.offers?.name}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}
